export function setDocumentDirectionPerLocale(locale: string): void {
  document.dir = locale === "he-IL" ? "rtl" : "ltr";
}

export function setDocumentLang(lang: string): void {
  document.documentElement.lang = lang;
}
